<template>
      <div class="container bg-gray-100 p-10">
        <router-link type="button" class="hover:underline" to="/">
        <!-- <a type="button" class="hover:underline" @click="$router.go(-1)"> -->
            <svg class="h-8 w-8 fill-current text-blue-900" xmlns="http://www.w3.org/2000/svg" viewBox="274.835 394.86 54.965 55.15"><defs/><path d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"/></svg>
       <!-- </a> -->
        </router-link>
          <div class="shadow-2xl bg-white p-5">
            <p class="text-gray-700 text-center text-3xl mb-5">¡Captura de Folios!</p>
            <p class="text-gray-700 text-center mb-5">Igresa los números de folio requeridos para generar solicitudes</p>

        <form autocomplete="off" @submit.prevent="onSubmit()" class="flex flex-wrap">
        <!-- <form @keydown.enter.prevent.self="onSubmit" class="flex flex-wrap"> -->
        <div class="md:container lg:container xl:container w-full lg:w-1/2 xl:w-1/2 lg:p-10 xl:p-10 flex flex-wrap">
        <div class="w-full">
            <label class="mt-2 mb-2">
                Folio inicial
            </label>
            <input
            type="text" 
            required
            v-model="initialFolio"
            max=69
            @keydown.enter.prevent.self
            v-maska="'##########'"
            title="Debe tener 10 dígitos"
            class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker">
        </div>
        </div>
        
        <div class="md:container lg:container xl:container w-full lg:w-1/2 xl:w-1/2 lg:p-10 xl:p-10 flex flex-wrap">
        <div class="w-full">
            <label class="mt-2 mb-2">
                Folio final
            </label>
            <input
            type="text" 
            required
            v-model="finalFolio"
            max=69
            @keydown.enter.prevent.self
            v-maska="'##########'"
            title="Debe tener 10 dígitos"
            class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker">
        </div>
        </div>

            <div class="w-full flex justify-center p-2 text-center mt-5 mb-2">
                <button class="w-full flex justify-center items-center md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-lg md:text-xl lg:text-xl lx:text-xl text-white font-bold py-2 px-6 rounded">
                    Generar <mdicon name="chevron-right" />
                </button>
            </div>

            </form>

          </div>

      </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: 'CaptureFolio',
    components: {
    },
  data() {
    return {
        initialFolio: null,
        finalFolio: null
    }
  },
    methods:{
        onSubmit() {
            console.log(this.initialFolio)
            console.log(this.finalFolio)

            if(Number(this.initialFolio) > Number(this.finalFolio)){
                Swal.fire({
                    icon: 'error',
                    title: 'Error.',
                    text: 'El folio inicial no puede ser mayor al folio final.',
                  })
            } else {
                Swal.fire({
                    icon: 'success',
                    title: 'Registro exitoso',
                    text: 'Los folios se han registrado exitosamente.',
                  })   
            }
        },
    }
}
</script>

<style scoped>

</style>